import { ContextualMenu, Icon, Stack } from "@fluentui/react";
import React, { useContext,useState,useRef,useCallback } from "react";
import RowBadge from "./Badge/RowBadge";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import studylistContext from "../../../context/studylist/StudylistContext";
import { IconButton } from "@fluentui/react";
import userContext from "../../../context/users/UserContext";
import EditPatientModal from "./EditPatient/EditPatientModal";
import {
  mainStackStyles,
  patientIdStyle,
  patientGenderStyle,
  patientAgeStyle,
  patientAgeChatContainer,
  patientAgeContainer,
  patientChatContainer,
  popDotStyle,
  countMessageStyle,
} from "../helpers/mobileUtilities";
import { HIDE_ASSIGN_DROPDOWN_TABS, MODAL_TYPE, RESTRICTED_STORAGE_TYPES, STORAGE_TYPE, TAB_NAME, TOAST_TYPE, USERTYPES, VDCLIMS, modalityRowBadgeColor, storageType } from "../../../constants/Constants";
import themeContext from "../../../context/theme/ThemeContext";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import { t } from "i18next";
import { RevertCloseStudyApi, addToLibraryApi, getPaymentStatusOfStudy, removeFromLibraryApi, updateStudyEmergencyOnlyAPI, deleteStudyApi } from "../../../service/StudyListService";
import ShareStudyLink from "./Actions/ShareStudyLink";
import CloseStudy from "./Actions/CloseStudy";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import loaderContext from "../../../context/loader/LoaderContext";
import { HistoryAttachment } from "./StudyDetails";
import UploadHistory from "./UploadHistory/UploadHistory";
import { capitalizeFullName } from "../helpers/helpingFunctions";
import toastContext from "../../../context/toast/ToastContext";
import { getEnv } from '../../../helpers/EnvHelper';
import { getRadiologistDisplayName } from "../../../helpers/CommonUtility";
import SetEmergencyModal from "./EditPatient/SetEmergencyModal";
import Emergency from "../../../components/SVGComponents/Emergency";
import NonMedicalEmergency from "../../../components/SVGComponents/NonMediclEmergency";

const MobileListComponent = (props) => {
  const {
    returnedReasonCount,
    setShowCommunicationModal,
    showReturnedStudyReasonModal,
    setShowReturnedStudyReasonModal,
    mobileAssignmentObject,
    setMobileAssignmentObject,
    showVersionModalForReport,dataQueryState, setDataQueryState,
    refreshRequired, setRefreshRequired,
    allDataElement, setAllDataElement,
    enableHistoryUpload,
    allowDeleteStudy,  allowStudyEdit,
    showChats
  } = useContext(studylistContext);


    const {
      setStudyParentId,
      openReportModal,
      setOpenReportModal,
      setModalityReport,
      reportDetails,
      getData,
      studyParentId,
      setFirmId,
      firmId,
      setIsExternal,
      handlePreviewReport,
      downloadReport,
      setAlertSuccessModal,
      alertSuccessModal,
      getConsistentCustomDateFormat, getConsistentDateFormat,
      externalReportingModalRef,externalReportingLoading,setExternalReportingLoading
    } = useContext(studyReportContext);

  const { theme,themeName, getThemeColor } = useContext(themeContext);
  const { roles, authenticated, loadByUsername, showConfirmation, isActiveData, contextSwitchUser } =
    useContext(userContext);
    const { setLoaderRunning, ref, setShowModal, showModal} = useContext(loaderContext);
    const { showToastv2 } = useContext(toastContext);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showReInferenceModal, setShowReInferenceModal] = useState(false);
    const [showCloseStudyModal, setShowCloseStudyModal] = useState(false);    
    const [showCloseStudyResponseModal, setShowCloseStudyResponseModal] = useState(false);
    const [showCloseStudyReponseMsg, setShowCloseStudyReponseMsg] = useState("");
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [showHistoryAttachment, setShowHistoryAttachment] = useState(false);
    const [showShareStudyLinkModal, setShowShareStudyLinkModal] = useState(false);
    const [shareStudyNotAllowed, setShareStudyNotAllowed] = useState(false);
    const [showSetEmergencyModal, setShowSetEmergencyModal] = useState(false);
    const [showEditPatientModal, setShowEditPatientModal] = useState(false);
    const [showEditPatientErrorModal, setShowEditPatientErrorModal] = useState(false);
    const [showEditPatientErrorMessage, setShowEditPatientErrorMessage] = useState("");


  let isBucketManagement = (getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == "true" || getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == true) ? true : false;
  let study = props.data.row.original;
  let studyId = props.data.row.original.id;
  let patientName = props.data.row.original.patientName;
  let patientId = props.data.row.original.patientId;
  let orderId= props.data.row.original.orderId;

  const copyTextToClipboard = async (text) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return;
      }
  const showEditPatientModalFunc = () => {
    setShowEditPatientModal(true);
  }

  const handleCloseEditPatientErrorModal = () => {
    setShowEditPatientErrorModal(false);
    setShowConfirmModal(false);
  }

      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.setAttribute("readonly", "");
      textArea.style.position = "absolute";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    };

    const handleCopyPatientStudyDetails = async (event) => {
      event.stopPropagation();
      event.preventDefault();

      const patientStudyDetails = [
        `Patient name: ${patientName || ""}`,
        `PatientId: ${patientId || ""}`,
        ...(getEnv("REACT_APP_VDC_PLATFORM") == "true"
        ? [`OrderId: ${orderId || ""}`]
        : []),
        `Accession Number: ${study.accessionNumber || ""}`,
        `Gender: ${study.patientSex || ""} | Age: ${study.patientAge || ""} | Modality: ${study.modality?.name || ""}`,
        `Study desc: ${study.studyDescription || ""}`,
      ].join("\n");
    
      try {
        await copyTextToClipboard(patientStudyDetails);
        showToastv2(TOAST_TYPE.SUCCESS, "Patient and Study details copied");
      } catch (error) {
        console.error("Clipboard error:", error);
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
      }
    };

  let enterprise =
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true
      ? true
      : false;

  const extractCorrectAge = (str) => {
    if (str[str.length - 1] == "Y" && str[0] == "0") {
      return str.substring(1, str.length - 1);
    }
    return str;
  };

  const badgeStyle = {
    backgroundColor: "#BBDEFF",
    height: "18px",
    fontSize: "10px",
    color: "#0035BE",
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    fontFamily: "Open Sans",
    fontWeight: "700",
    padding: "0px 5px",
    borderRadius: "10px",
    lineHeight: "16px",
    gap: "10px",
  };

 

  const handleCloseStudy = () =>{
    setShowConfirmModal(true);
    setShowCloseStudyModal(true);
  }

  const handleCloseStudyResponseCloseModal = () =>{
    setShowCloseStudyResponseModal(false);
  }

  const handleDeleteStudy = () =>{
    setShowConfirmModal(true);
    setShowDeleteConfirmModal(true);
  }

  const handleDeleteSuccessCloseModal = () =>{
    setShowDeleteConfirmModal(false);
    setShowConfirmModal(false);
  }

  const handleRemoveRowForDeletedStudy = () => {
    let newData = dataQueryState?.data?.rows.filter(
      (row) => row.id != studyId
    );
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      newValue.data.rows = newData;
      return newValue;
    });
  }

  const deleteStudyFunc = async() =>{
    setShowDeleteConfirmModal(false);
    setShowConfirmModal(false);
    try {
      const response = await deleteStudyApi(studyId, false);
      if(response.data.result == "FAILURE"){
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = response.data.message == "database_error" ? t("confirm-message.delete-database-error-message") : response.data.message;
          return newItem;
        });
      } else {
        handleRemoveRowForDeletedStudy();
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("confirm-message.delete-success-message");
          return newItem;
        });
      }
    } catch (e) {
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  }

  const handleAddToLibrary = async() =>{
    const response = await addToLibraryApi(studyId);
    console.log("---- Library added ----",response);
    if(response.data.result == "SUCCESS"){
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description =  t("string-literals.add-to-library-success");
        return newItem;
      });

      setAllDataElement(prevData => {
        const newData = [...prevData];
        newData[props.data.row.index] = {
          ...newData[props.data.row.index], 
          libraryStudy: true 
        };
        return newData;
      });
      setTimeout(()=>{
        setRefreshRequired(()=>{
          const newItem = {...refreshRequired};
          newItem[TAB_NAME.LIBRARY].alreadyLoaded = false;
          return newItem;
        });
      },10);
      

    }else{
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  }

  const handleRemoveFromLibrary = async() =>{
    const response = await removeFromLibraryApi(studyId);

    if(response.data.result == "SUCCESS"){
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.removed-to-library-success");
        return newItem;
      });
      if(props.tabId == TAB_NAME.LIBRARY){

        setTimeout(()=>{
          setRefreshRequired(()=>{
            const newItem = {...refreshRequired};
            newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
            console.log(newItem);
            return newItem;
          });
        },10);  
        setAllDataElement(prevData => {
          const newData = prevData.filter(element => element.id !== studyId);
          return newData;
        });    
      }else{
        setAllDataElement(prevData => {
          const newData = [...prevData];
          newData[props.data.row.index] = {
            ...newData[props.data.row.index], 
            libraryStudy: false 
          };
          return newData;
        });
      }
      


    }else{
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  }

  const mapChoiceToKey = (choice) => {
    if (choice === "NONE") return 1;
    if (choice === "NON_MEDICAL") return 3;
    return 2;
  };

  const updateEmergency = useCallback(async (choice) => {
    try {
      setLoaderRunning(true);
      ref.current.continuousStart();

      const emergencyKey = mapChoiceToKey(choice);
      const response = await updateStudyEmergencyOnlyAPI(studyId, emergencyKey);

      setLoaderRunning(false);
      ref.current.complete();

      if (response?.status === 200 && response?.data?.result === "SUCCESS") {
        const isNone = emergencyKey === 1;
        const updatedEmergencyState = {
          emergency: !isNone,
          nonMedicalEmergency: emergencyKey === 3,
        };

        setDataQueryState((prev) => {
          const next = { ...prev };
          next.data = { ...prev.data };
          next.data.rows = prev.data.rows.map((row, index) =>
            index === props.data.row.index ? { ...row, ...updatedEmergencyState } : row
          );
          return next;
        });

        setAllDataElement((prevData) =>
          prevData.map((row, index) =>
            index === props.data.row.index ? { ...row, ...updatedEmergencyState } : row
          )
        );

        showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.update-success"));
      } else {
        throw new Error("Failed to update emergency status");
      }
    } catch (_) {
      setLoaderRunning(false);
      ref.current.complete();
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.failed-message");
        return newItem;
      });
    } finally {
      setShowSetEmergencyModal(false);
    }
  }, [studyId, props.data.row.index, setDataQueryState, setAllDataElement, setLoaderRunning, ref, showToastv2, setShowModal, showModal]);

  const handleRevertCloseStudyApiFunc = async() =>{
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await RevertCloseStudyApi(studyId, props.data.row.original.assignmentList[0].id);
    if(response.data.message === "database_error"){
      // setShowRevertStudyResponseMsg(t("confirm-message.revert-closeStudy-database-error-message"));
      setLoaderRunning(false);
      ref.current.complete();
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("confirm-message.revert-closeStudy-database-error-message");
        return newItem;
      });
       

      
    }else{
      // setShowRevertStudyResponseMsg(response.data.message);
      setLoaderRunning(false);
      ref.current.complete();
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = response.data.message;
        return newItem;
      });

      setRefreshRequired(()=>{
        const newItem = {...refreshRequired};
        newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
        return newItem;
      });

    let newData = dataQueryState?.data?.rows.filter(
      (row) => row.id !== props.data.row.original.id
    );
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      newValue.data.rows = newData;
      return newValue;
    });
    }
  }
  const showEditPatientModalFunc = () => {
    setShowEditPatientModal(true);
  }

  const handleCloseEditPatientErrorModal = () => {
    setShowEditPatientErrorModal(false);
    setShowConfirmModal(false);
  }


  const handleShareStudyLink = async () => {
    if (study.storageType === STORAGE_TYPE.COLD_STORAGE) {
      setShareStudyNotAllowed(true);
      return;
    }

    const response = await getPaymentStatusOfStudy(studyId);
    if (response.data.result === "SUCCESS") {
      const status = response.data.data;
      if (status == VDCLIMS.PaymentStatusCodes.PAID) {
        setShowShareStudyLinkModal(true);
      } else {
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description =
            status == VDCLIMS.PaymentStatusCodes.DUE
              ? t("payment-status.payment-due-message")
              : t("payment-status.payment-error-message");
          return newItem;
        });
      }
    } else {
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("payment-status.payment-error-message");
        return newItem;
      });
    }
  };

  const menuPropsItems = () =>{
    let items = [];

    if (
      props.tabId != TAB_NAME.CLOSED &&
      (!isBucketManagement ||
        (!RESTRICTED_STORAGE_TYPES.includes(study.storageType) &&
          study.storageType !== storageType.COLD_STORAGE))
    ) {
      items.push({
        key: "ShareStudyLink",
        iconProps: {
          iconName: "studyListShareStudy",
          className: "study-list-action-icon-class",
        },
        text: t("share-study.title"),
        onClick: () => handleShareStudyLink(),
      });
    }
    if (
      roles[0] == USERTYPES.ADMIN ||
      roles[0] == USERTYPES.FIRMADMIN ||
      roles[0] == USERTYPES.FIRMDOCTOR ||
      roles[0] == USERTYPES.SUPERVISOR ||
      roles[0] == USERTYPES.FIRMTECHNICIAN
    ) {
            if (
        isActiveData &&
        !contextSwitchUser &&
        ((getEnv("REACT_APP_VDC_PLATFORM") == "true" ||
          getEnv("REACT_APP_BVP_PLATFORM") == "true")
          ?
            (roles[0] === USERTYPES.SUPERVISOR ||
              roles[0] === USERTYPES.ADMIN ||
              roles[0] === USERTYPES.FIRMADMIN ||
              study.reportDoneStatus < 2)
          :
            study.reportDoneStatus != 2) &&
        (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType)) &&
        props.data.row.depth === 0 &&
        !((roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMTECHNICIAN) && !allowStudyEdit)
      ) {
        items.push({
          key: "editPatient",
          iconProps: {
            iconName: "EditPatientIcon",
            className: "study-list-action-icon-class",
          },
          text: t("study-list.actions.edit-patient"),
          onClick: () => showEditPatientModalFunc(),
        });
      }
    }


    if(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN ||  roles[0] == USERTYPES.SUPERVISOR){
      if(
        props.data.row.depth === 0 &&
        ((roles[0] == USERTYPES.ADMIN && ((study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null) || study.assignmentList[0].firmName == 'firsthospital')) ||
        (roles[0] == USERTYPES.FIRMADMIN && ((((enterprise || (!enterprise && study.assignmentList[0].clientId == 0)) && study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null) || study.assignmentList[0].firmName == 'firsthospital'))) ||
        (roles[0] == USERTYPES.SUPERVISOR && String(allowDeleteStudy).toLowerCase() === 'true' && ((((enterprise || (!enterprise && (study.assignmentList[0].clientId == 0 || (study?.studyFromMinimalFirm && study?.sourceFirmId == study.assignmentList[0].clientId)))) && study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null) || study.assignmentList[0].firmName == 'firsthospital'))))
      ){
        items.push({
          key: 'DeleteStudy',
          iconProps: { iconName: 'DeleteCustomIcon',className: 'study-list-action-icon-class' },
          text: t("study-list.actions.delete-study"),
          onClick: () => handleDeleteStudy(),
        });
      }
      if(study.assignmentList[0].closed == 0 && study.reportDoneStatus != 2 && props.data.row.depth === 0){
        items.push({
          key: 'CloseStudy',
          iconProps: { iconName: 'CloseStudyIcon',className: 'study-list-action-icon-class' },
          text: t("study-list.actions.close-study"),
          onClick: () => handleCloseStudy(),
        });
      }
      if(props.data.row.depth === 0 && study.assignmentList[0].closed > 0 && study.reportDoneStatus != 2 && (study.assignmentList[0].closed == study.assignmentList[0].firmId)){
        items.push({
          key: 'RevertCloseStudy',
          iconProps: { iconName: 'RevertCloseStudyIcon',className: 'study-list-action-icon-class' },
          text: t("study-list.actions.revert-close-study"),
          onClick: () => handleRevertCloseStudyApiFunc(),
        });
      }
      if(study.assignmentList[0].closed != 0 && study.reportDoneStatus != 2 && props.tabId == 'closed'  && props.data.row.depth === 0 ){
        items.push({
          key: 'closeStudyReason',
          iconProps: {iconName: 'ReturnStudyIcon',className: 'study-list-action-icon-class'},
          text: t("study-list.actions.close-study-reason"),
          onClick:() => {
            console.log("---Clicked---");
            setShowModal(() => {
              const newItem = { ...showModal };
              newItem.show = true;
              newItem.type = MODAL_TYPE.ALERT_MODAL;
              newItem.heading = "Closing Reasons";
              newItem.isError = false;
              newItem.isSuccess = false;
              newItem.isWarning = true;
              newItem.description = study.assignmentList[0].closingReason;
              return newItem;
            });
          }
        });
      }
    
    if(roles[0] == USERTYPES.RADIOLOGIST){
      if(!study.libraryStudy){
        if(props.data.row.depth === 0){
          items.push({
            key: 'AddToLibrary',
            iconProps: {iconName: 'AddToLibraryIcon',className: 'study-list-action-icon-class'},
            text: t("study-list.actions.add-to-library"),
            onClick:() => handleAddToLibrary()
          });
        }
        
      }else{
        if(props.data.row.depth === 0){
          items.push({
            key: 'RemoveFromLibrary',
            iconProps: {iconName: 'RemoveFromLibraryIcon',className: 'study-list-action-icon-class'},
            text: t("study-list.actions.remove-from-library"),
            onClick:() => handleRemoveFromLibrary()
          });
        }
      }
    }
      
      // items.push({
      //   key: 'viewReportHistory',
      //   iconProps: {iconName: 'ReportHistoryIcon',className: 'study-list-action-icon-class'},
      //   text: t("study-list.actions.report-history"),
      //   onClick:() => {}
      //     //handleViewReportHistory()
      // });
    }
    // if(roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.FIRMTECHNICIAN){
    //     if(study.wordFilePath != null && study.wordFilePath != ""){
    //       items.push({
    //         key: 'viewReportHistory',
    //         iconProps: {iconName: 'ReportHistoryIcon',className: 'study-list-action-icon-class'},
    //         text: t("study-list.actions.report-history"),
    //         onClick:() => {} 
    //           //handleViewReportHistory(false)
    //       });
    //     }
    //  }

    if((roles[0] === USERTYPES.FIRMTECHNICIAN || roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMADMIN) && study.reportDoneStatus != 2 ){
      if(isActiveData && props.data.row.depth === 0 && (!isBucketManagement || !RESTRICTED_STORAGE_TYPES.includes(study.storageType))){
        const hasEmergency = !!(study.emergency || study.nonMedicalEmergency);

        if (hasEmergency) {
          items.push({
            key: 'RemoveEmergency',
            iconProps: {
              iconName: 'Cancel',
              className: 'study-list-action-icon-class',
              style: { color: getThemeColor('icon-color') },
            },
            text: 'Mark as No Emergency',
            onClick: () => updateEmergency('NONE'),
          });
        } else {
          items.push({
            key: 'SetEmergency',
            iconProps: {
              iconName: 'WarningSolid',
              className: 'study-list-action-icon-class',
              style: { color: getThemeColor('icon-color') },
            },
            text: 'Set Emergency',
            onClick: () => setShowSetEmergencyModal(true),
          });
        }
      }
    }

    if(
      (roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST
      || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.TYPIST) &&
       (study.reportDoneStatus == 1 ||
        study.reportDoneStatus == 2 ||
        study.reportDoneStatus == 6 ||
        props.tabId === TAB_NAME.DRAFT)){
        items.push({
          key: 'Preview',
          iconProps: { iconName: 'PreviewStudyListIcon',className: 'study-list-action-icon-class' },
          text: 'Preview Report',
          onClick: () => handlePreviewReport(studyId, study.reportDoneStatus, props.tabId === TAB_NAME.DRAFT),
        });
      }

    return items;
  }

  const menuProps = {
    shouldFocusOnMount: true,
    items: menuPropsItems(),
  };

  const checkForAssignementAccess = () => {
    if((roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR) && props.data.row.original.allowAssignment && !HIDE_ASSIGN_DROPDOWN_TABS.includes(props.tabId)){
      return true;
    }
    return false;
  }

  const checkForProviderAccess = () => {
    if(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.RADIOLOGIST){
      return true;
    }
    return false;
  }

  const checkForClientAccess = () => {
    if(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR){
      return true;
    }
    return false;
  }

  const getProviderName = () => {
    let nameStr = "";
    if(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.RADIOLOGIST){
      if(props.data.row.original.assignmentList[0]?.closedByProvider){
        nameStr += `${t("label.closed")} `;
      }
      const assignment = props.data.row.original.assignmentList[0];
      nameStr += assignment?.providerName != undefined
        ? getRadiologistDisplayName({
            name: assignment.providerName,
            specialist: assignment.specialist,
          })
        : "-";
    }
    return nameStr;
  }

  const getClientName = () => {
    if(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR){
      return props.data.row.original.assignmentList[0].clientName !=
      undefined ? props.data.row.original.assignmentList[0].clientName : "-";
    }
    return "-";
  }

  const checkForAnyUploadedHistory = () => {
    if((props.data.row.original?.historyStatus == null || props.data.row.original?.historyStatus == false) && props.data.row.original?.studyHistoryDocList?.length == 0){
        return false;
    }else{
      return true;
    }
  }

  const checkForRoleForHistoryIcon = () => {
    if(roles[0] !== USERTYPES.RADIOLOGIST){
      return true;
    }
    return false;
  }

  const getEmergencyIcon = () => {
    if (!study?.emergency) {
      return null;
    }

    if (study?.nonMedicalEmergency) {
      return {
        title: t("study-list.badges.non-medical-emergency"),
        icon: <NonMedicalEmergency />,
      };
    }

    return {
      title: t("study-list.badges.emergency"),
      icon: <Emergency />,
    };
  }

  const emergencyIcon = getEmergencyIcon();
  return (
    <>
      <Stack style={{ ...mainStackStyles }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
           {showCloseStudyModal &&
        <CloseStudy showCloseStudyModal={showCloseStudyModal} setShowCloseStudyModal={setShowCloseStudyModal} setShowCloseStudyResponseModal={setShowCloseStudyResponseModal} studyId={studyId} setShowConfirmModal={setShowConfirmModal} setShowCloseStudyReponseMsg={setShowCloseStudyReponseMsg} patientName={patientName} patientId={patientId}/>
      }
      {showCloseStudyResponseModal && showConfirmModal &&
        <ConfirmModal handleConfirm={handleCloseStudyResponseCloseModal} handleNotConfirm={handleCloseStudyResponseCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={showCloseStudyReponseMsg}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")}/>
      }
      {showDeleteConfirmModal && showConfirmModal &&
        <ConfirmModal handleConfirm={deleteStudyFunc} handleNotConfirm={handleDeleteSuccessCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={t("confirm-message.delete-confirm-message")}
          title={t("confirm-message.confirm-delete-study")} confirmButtonText={t("confirm-message.yes")} cancelButtonText={"Cancel"}/>
      }
      {showHistoryAttachment &&
        <UploadHistory 
        setShowUploadHistoryModal={setShowHistoryAttachment} 
        showUploadHistoryModal={showHistoryAttachment} 
        studyId={props.data.row.original.id} 
        isChild={props.data.row.depth !== 0}
        activeData = {props.data.row.original.fromActiveData}
        clientId={props.data.row.original.assignmentList[0]?.clientId} 
        firmId = {props.data.row.original.assignmentList[0]?.firmId} 
        modalityId = {props.data.row.original.modalityId}
        storageType={props.data.row.original.storageType} 
        reportDoneStatus={props.data.row.original.assignmentList[0]?.reportDoneStatus}
        />
      }
      {showShareStudyLinkModal && (
        <ShareStudyLink
          studyId={props.data.row.original.id}
          firmId={props.data.row.original.assignmentList[0].firmId}
          clientId={props.data.row.original.assignmentList[0].clientId}
          setShowShareStudyLinkModal={setShowShareStudyLinkModal}
        />
      )}
      {showEditPatientModal && (
        <EditPatientModal
          setShowEditPatientModal={setShowEditPatientModal}
          showEditPatientModal={showEditPatientModal}
          studyId={studyId}
          patientName={patientName}
          patientId={patientId}
          setShowEditPatientErrorModal={setShowEditPatientErrorModal}
          setShowEditPatientErrorMessage={setShowEditPatientErrorMessage}
          data={props.data}
        />
      )}
      {showEditPatientErrorModal && showConfirmModal && (
        <ConfirmModal
          handleConfirm={handleCloseEditPatientErrorModal}
          handleNotConfirm={handleCloseEditPatientErrorModal}
          setShowConfirmModal={setShowConfirmModal}
          showConfirmModal={showConfirmModal}
          message={showEditPatientErrorMessage}
          title={t("confirm-message.alert")}
          confirmButtonText={t("confirm-message.ok")}
        />
      )}

      {shareStudyNotAllowed && (
        <ConfirmModal
          handleCloseIcon={() => setShareStudyNotAllowed(false)}
          showConfirmModal={shareStudyNotAllowed}
          handleConfirm={() => setShareStudyNotAllowed(false)}
          message={t("image-archive.share-not-allowed-message")}
          confirmButtonText={t("confirm-message.ok")}
          title={t("image-archive.title")}
        />
      )}
      {showSetEmergencyModal && (
        <SetEmergencyModal
          show={showSetEmergencyModal}
          onClose={() => setShowSetEmergencyModal(false)}
          studyId={studyId}
          rowIndex={props.data.row.index}
          dataRow={study}
          defaultKey={study?.nonMedicalEmergency ? 3 : 2}
          onSubmit={(key) => updateEmergency(key === 3 ? 'NON_MEDICAL' : 'MEDICAL')}
        />
      )}
      {
        checkForAnyUploadedHistory() && <div className={`${checkForRoleForHistoryIcon()?"mobile-add-history-icon":"mobile-add-provider-icon"}`}>
          <IconButton
              iconProps={{ iconName: checkForRoleForHistoryIcon() ? "DownloadDocument":"FilePDB" }}
              style={{ color: "#0082F9", border: "none", outline: "none" }}
              onClick={(ev)=>{
                ev.stopPropagation();
                setShowHistoryAttachment(true);
              }}
            />
        </div>
      }
          {checkForAssignementAccess() && <div className="mobile-add-provider-icon">
            <IconButton
              iconProps={{ iconName: "AddFriend" }}
              style={{ color: "#0082F9", border: "none", outline: "none" }}
              onClick={(ev)=>{
                ev.stopPropagation();
                console.log("--- CLicking provider ---");
                setMobileAssignmentObject(()=>{
                  const newItem = {...mobileAssignmentObject};
                  newItem.showProviderFilter = true;
                  newItem.index = 0;
                  newItem.data = props.data;
                  return newItem;
                })
              }}
            />
          </div>}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span className="study-list-mobile-patientDetails-name">
                {capitalizeFullName(props.data.row.original.patientName)}
              </span>
            </div>

            <div style={{ height: "fit-content", display: "flex" }}>
                 {emergencyIcon && (
                <div
                  title={emergencyIcon.title}
                  style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}
                  onClick={(event) => event.stopPropagation()}
                >
                  {emergencyIcon.icon}
                </div>
              )}
               <div
                  style={{
                    marginLeft: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={(event) => event.stopPropagation()}
                >
                  <HistoryAttachment
                    data={props.data}
                    setShowUploadHistoryModal={setShowHistoryAttachment}
                  />
                </div>
              {((roles[0] === USERTYPES.TYPIST && showChats) || (roles[0] !== USERTYPES.TYPIST)) && (
              <div
                style={patientChatContainer}
                onClick={(event) => {
                  event.stopPropagation();
                  setShowCommunicationModal({
                    studyId: props.data.row.original.id,
                    show: true,
                  });
                }}
              >
                {props.data.row.original.userSpecificMessageCount > 0 && (
                  <div style={popDotStyle}>
                    <span style={countMessageStyle}>
                      {props.data.row.original.userSpecificMessageCount}
                    </span>
                  </div>
                )}
                {/* <RowBadge
                name={props.data.row.original.modality.name}
                style={badgeStyle}
              /> */}
               
                <div
                  style={{
                    marginLeft: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <ChatIcon
                    color={theme.palette.inactiveTool}
                    active={
                      props.data.row.original.userSpecificMessageCount > 0
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
              )}
              <div style={{marginLeft:"14px"}}>
                <IconButton iconProps={{ iconName: "Copy" }} onClick={handleCopyPatientStudyDetails} styles={{
                  root: {
                    color: getThemeColor("icon-color"),
                    backgroundColor: "transparent",
                  },
                  rootHovered: {
                    color: getThemeColor("icon-color"),
                    backgroundColor: "transparent",
                  },
                  rootPressed: {
                    color: getThemeColor("icon-color"),
                    backgroundColor: "transparent",
                  },
                  rootFocused: {
                    backgroundColor: "transparent",
                  },
                  icon: {
                    fontSize: "14px",
                  },
                }}/>
              </div>
              <ActionDropdown menuItems={menuPropsItems} />
            </div>
          </div>
          <div style={patientAgeChatContainer}>
            <div style={patientAgeContainer}>
              <span style={patientGenderStyle}>
                {props.data.row.original.patientSex}
              </span>
              <span style={{ marginLeft: "4px", marginRight: "4px" }}>|</span>
              <span style={patientAgeStyle}>
                {props.data.row.original.patientAge == 0
                  ? props.data.row.original.patientAge.substring(1)
                  : extractCorrectAge(props.data.row.original.patientAge)}
              </span>
            </div>
            <div style={patientChatContainer}>
              <RowBadge
                customClassName = "study-list-modality-badge"
                colorObj={modalityRowBadgeColor(
                  props.data.row.original.modality.name
                )}
                name={props.data.row.original.modality.name}
              />
              <span
                className="study-list-mobile-study-date-txt"
                style={{ marginLeft: "10px" }}
              >
                {`ID: `}
                <span className="study-list-value-text">
                  {props.data.row.original.patientId}
                </span>
              </span>
            </div>
          </div>
          <div style={{ display: "flex", width:"100%" }}>
            <div style={{ display: "flex", flexDirection: "column", width:"25%" }}>
              <span className="study-list-mobile-study-date-txt">{`Study Date: `}</span>
              <span className="study-list-mobile-total-no-of-images-txt">{`${t("label.total-images")}: `}</span>
              {checkForClientAccess() && <span className="study-list-mobile-study-date-txt">{`Client: `}</span>}
              {checkForProviderAccess() && <span className="study-list-mobile-study-date-txt">{`${roles[0] === USERTYPES.RADIOLOGIST?"Radiologist":"Provider"}: `}</span>}
              {checkForProviderAccess() && <span className="study-list-mobile-study-date-txt">{`Assigned On: `}</span>}
              <span className="study-list-mobile-study-date-txt">{`Description: `}</span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width:"70%",
                paddingLeft:"3px"
              }}
            >
              <span className="study-list-value-text">
                {getConsistentDateFormat(
                  props.data.row.original.studyDateDisplay
                )}
              </span>
              <span className="study-list-value-text">
                {props.data.row.original.noOfImages}
              </span>
              {checkForClientAccess() && <span className="mobile-study-list-text-value" style={{ width: "230px",display:'block' }}>
                {getClientName()}
              </span>}
              {checkForProviderAccess() && <span className="mobile-study-list-text-value" style={{ width: "230px",display:'block' }}>
                {getProviderName()}
              </span>}
              {checkForProviderAccess() && <span className="study-list-value-text">
                {getConsistentCustomDateFormat(
                  props.data.row.original.assignmentList[0]
                    .assignmentDateDisplay
                )}
              </span>}
              <span className="study-list-value-text">
                {props.data.row.original.studyDescription}
              </span>
            </div>
          </div>

          <span
            className="study-list-patientDetails-id"
            style={{ marginBottom: "10px" }}
          >
            <span className="study-list-mobile-top-badge-container">
              {props.data.row.original.edited &&
                props.data.row.original.reportDoneStatus < 2 && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: " #CE980D" }}
                  >
                    EDITED
                  </span>
                )}
            </span>
          </span>
        </div>
      </Stack>
    </>
  );
};

export default MobileListComponent;

const ActionDropdown = ({ menuItems }) => {
  const [showContextualMenu, setShowContextualMenu] = useState(false);
  const { getThemeColor } = useContext(themeContext);
  const onHideContextualMenu = useCallback(
    () => setShowContextualMenu(false),
    []
  );
  const linkRef = useRef(null);

  const contextMenuStyle = {
    root: {
     backgroundColor: getThemeColor('action-details-background'),
     borderRadius: "5px",
    border: "1px solid #585858",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
    },
    item: {
      selectors: {
      ":hover": {
        backgroundColor:'green'
      },
      },
    },
  };

  return (
    <>
      <div
        ref={linkRef}
        className="study-list-actions-icon study-list-context-menu"
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "5px",
          marginLeft: "14px"
        }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setShowContextualMenu((prev) => !prev);
        }}
      >
        <Icon
          iconName="MoreVertical"
          style={{fontSize:"18px"}}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setShowContextualMenu((prev) => !prev);
          }}
        ></Icon>
        <ContextualMenu
          styles={contextMenuStyle}
          items={menuItems()}
          hidden={!showContextualMenu}
          target={linkRef}
          onItemClick={onHideContextualMenu}
          onDismiss={onHideContextualMenu}
          isBeakVisible={false}
        />
      </div>
    </>
  );
};
